
// Drawing data for Tom's sketch gallery
// size format: "2x2" means 2 columns x 2 rows
export const drawings = [
  {
    id: "114",
    date: "2025/11/13",
    size: "2x2",
    src: "/drawings/sketch-1200px (1).png"
  },
  {
    id: "112",
    date: "2025/11/13",
    size: "1x1",
    src: "/drawings/sketch-600px (20).png"
  },
  {
    id: "094",
    date: "2025/11/13",
    size: "1x2",
    src: "/drawings/sketch-600px (2).png"
  },
  {
    id: "109",
    date: "2025/11/13",
    size: "1x1",
    src: "/drawings/sketch-600px (17).png"
  },
  {
    id: "096",
    date: "2025/11/13",
    size: "2x2",
    src: "/drawings/sketch-600px (4).png"
  },
  {
    id: "101",
    date: "2025/11/13",
    size: "2x2",
    src: "/drawings/sketch-600px (9).png"
  },
  {
    id: "108",
    date: "2025/11/13",
    size: "1x1",
    src: "/drawings/sketch-600px (16).png"
  },
  {
    id: "107",
    date: "2025/11/13",
    size: "2x1",
    src: "/drawings/sketch-600px (15).png"
  },
  {
    id: "105",
    date: "2025/11/13",
    size: "2x1",
    src: "/drawings/sketch-600px (13).png"
  },
  {
    id: "104",
    date: "2025/11/13",
    size: "1x1",
    src: "/drawings/sketch-600px (12).png"
  },
  {
    id: "098",
    date: "2025/11/13",
    size: "2x2",
    src: "/drawings/sketch-600px (6).png"
  },
  {
    id: "103",
    date: "2025/11/13",
    size: "1x1",
    src: "/drawings/sketch-600px (11).png"
  },
  {
    id: "097",
    date: "2025/11/13",
    size: "1x1",
    src: "/drawings/sketch-600px (5).png"
  },
  // {
  //   id: "102",
  //   date: "2025/11/13",
  //   size: "1x1",
  //   src: "/drawings/sketch-600px (10).png"
  // },
  {
    id: "113",
    date: "2025/11/13",
    size: "2x2",
    src: "/drawings/sketch-1200px.png"
  },
  {
    id: "111",
    date: "2025/11/13",
    size: "1x1",
    src: "/drawings/sketch-600px (19).png"
  },
  {
    id: "110",
    date: "2025/11/13",
    size: "1x1",
    src: "/drawings/sketch-600px (18).png"
  },
  {
    id: "100",
    date: "2025/11/13",
    size: "2x2",
    src: "/drawings/sketch-600px (8).png"
  },
  {
    id: "099",
    date: "2025/11/13",
    size: "1x1",
    src: "/drawings/sketch-600px (7).png"
  },
  {
    id: "095",
    date: "2025/11/13",
    size: "1x1",
    src: "/drawings/sketch-600px (3).png"
  },
  {
    id: "093",
    date: "2025/11/13",
    size: "1x1",
    src: "/drawings/sketch-600px (1).png"
  },
  {
    id: "092",
    date: "2025/11/13",
    size: "1x1",
    src: "/drawings/sketch-600px.png"
  },
  // {
  //   id: "091",
  //   date: "2025/11/13",
  //   size: "1x1",
  //   src: "/drawings/sketch-300px (3).png"
  // },
  {
    id: "106",
    date: "2025/11/13",
    size: "1x2",
    src: "/drawings/sketch-600px (14).png"
  },
  {
    id: "090",
    date: "2025/11/13",
    size: "1x1",
    src: "/drawings/sketch-300px (2).png"
  },
  {
    id: "089",
    date: "2025/11/13",
    size: "1x1",
    src: "/drawings/sketch-300px (1).png"
  },
  {
    id: "088",
    date: "2025/11/13",
    size: "1x2",
    src: "/drawings/sketch-300px.png"
  },

];
